<template>
    <label class="switch" :for="id">
        <input type="checkbox" :id="id" @change="handleChange" @input="$emit('input',$event.target.checked)" :checked="value">
        <span class="slider round"></span>
    </label>
</template>

<script>
    import { uuid } from '../../modules/helpers.js';
    export default {
        name: "ToggleSwitch",
        props: ['label', 'value'],
        data: () =>  {
            return {
                id: uuid(),
            }
        },
				methods: {
						handleChange(event) {
								//this.$emit('input', event.target.checked);
								this.$emit('change', event.target.checked);
						}
				}
    }
</script>

<style scoped lang="scss">
    /* The switch - the box around the slider */
    .switch {
        transform: scale(0.75);
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $ss-grey2;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: $primary;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $primary;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

</style>
